// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"eae3eb1a","867":"9e8b5134"}[chunkId] + ".chunk.js";
};